/**
 * 投资机会条目（找投资页）
 *
 * 采集规范：
 * - url 必须是**官方一手来源**（政府部门 *.gov.cn、主管部门直属平台、赛事官方站），
 *   不用媒体转载 / 公众号 / 第三方聚合站；入库前需验证链接可访问。
 * - region 与园区库、政策库共用同一套简称（「北京」「广东」「雄安」），全国性机会统一用「全国」。
 * - 报名状态（已截止 / 报名中 / 持续更新）由 @/common/invest/render 渲染时按当天日期计算，
 *   此处只存 deadline 与 rolling，不要手写状态文案。
 */

/** 投资活动类型 */
export type InvestOpportunityType = 'contest' | 'roadshow' | 'park' | 'finance';

/** 投资活动类型 → 页面筛选用中文标签 */
export const INVEST_TYPE_LABEL: Record<InvestOpportunityType, string> = {
    contest: '创业赛事',
    roadshow: '路演对接',
    park: '园区项目',
    finance: '融资支持',
};

export interface InvestOpportunity {
    /** 唯一键，用于幂等更新与去重 */
    slug: string;
    /** 活动 / 项目征集的正式名称（不含书名号） */
    title: string;
    /** 类型枚举 */
    type: InvestOpportunityType;
    /** 类型中文标签，取自 INVEST_TYPE_LABEL */
    typeLabel: string;
    /** 发布机构全称 */
    issuer: string;
    /** 适用地区；全国性机会为「全国」 */
    region: string;
    /** 适合对象（一句话） */
    audience: string;
    /** 支持内容（一句话） */
    support: string;
    /** 报名截止日期 YYYY-MM-DD；无明确截止留空字符串 */
    deadline: string;
    /** true = 持续更新 / 按年度通知开放，不做截止判断 */
    rolling: boolean;
    /** 信息发布日期 YYYY-MM-DD；解析失败留空字符串 */
    publishDate: string;
    /** 官方原文链接 */
    url: string;
    /** 来源站点标记 */
    source: string;
}
